import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import Button from '../Button/Button';

const AppSnackbar = props => {
	const [open, setOpen] = React.useState(false);
	const { show } = props;

	useEffect(() => {
		setOpen(show);
	}, [show]);

	const handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		props.onClose();
		setOpen(false);
	};

	const renderActions = () => {
		return (
			props.actions.map(action => {
				return (
					<Button
						key={action.name}
						color="secondary"
						size="small"
						onClick={(event, reason) => {
							action.handler(event, reason);
							handleClose(event, reason);
						}}>
						{action.name}
					</Button>
				)
			})
		)
	}

	return (
		<Snackbar
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'center',
			}}
			open={open}
			autoHideDuration={10000}
			onClose={handleClose}
			message={props.message}
			action={
				<React.Fragment>
					{ props.actions.length > 0 ? renderActions() : null }
					<IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
						<CloseIcon fontSize="small" />
					</IconButton>
				</React.Fragment>
			}
		/>
	)
}

AppSnackbar.defaultProps = {
	show: false,
	actions: []
}

AppSnackbar.propTypes = {
	show: PropTypes.bool.isRequired,
	message: PropTypes.string,
	onClose: PropTypes.func,
	actions: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string.isRequired,
			handler: PropTypes.func.isRequired
		})
	)
}

export default AppSnackbar;